<template>
<v-card flat tile height='100%' >
  <v-overlay :value='loading' absolute >
    <center>
      <v-progress-circular indeterminate color='amber' class='mb-3' width='2' size=60 /><br/>
      Calculating your progress ..
    </center>
  </v-overlay>
  <v-card-title v-if='wiz' class='subtitle-1 overline py-0 grey lighten-4' >
    <v-icon v-if='wiz.icon' class='mr-2' color='blue' >{{wiz.icon}}</v-icon>
    {{ wiz.title }}
    <v-spacer/>
    <v-chip v-if='progress===100' x-small outlined label color='green' >
      Complete
      <v-icon small right >mdi-party-popper</v-icon>
    </v-chip>
  </v-card-title>
  <v-divider/>
  <v-progress-linear v-if='wiz' :value='progress' color='green' />
  <v-timeline v-if='wiz' dense clipped :disabled='wiz.disabled' >
    <template v-for='step in wiz.steps' >
      <v-timeline-item fill-dot small
        :key='step.title'
        :icon='getIcon(step)'
        :color='getColor(step)' >

        <v-btn small
          v-if='!step.done'
          class='float-right mr-4 mt-2' color='primary'
          :disabled='step.disabled'
          @click='ctaClicked(step)' >
          {{step.cta || 'Go'}}
          <v-icon small v-if='step.icon' class='ml-1' >{{ step.icon }}</v-icon>
        </v-btn>
        <v-btn small
          v-if='step.done === true && step.editText'
          @click='ctaClicked(step)'
          :disabled='step.disabled'
          class='float-right mr-4 mt-2' color='primary' >
          {{step.editText || 'Go'}}
          <v-icon small v-if='step.icon' class='ml-1' >{{ step.icon }}</v-icon>
        </v-btn>
        <div class='font-weight-light' >{{ step.title }}</div>
        <div
          v-if='step.description'  class='caption' >{{step.description}}</div>
        <!-- <v-checkbox
          :value='step.done'
          :label='step.title'
          :hint='step.description' persistent-hint dense small class='mb-2 ma-0 pa-0 pr-1' /> -->
        <!-- <div v-if='step.description' class='caption' >{{ step.description }}</div> -->
      </v-timeline-item>
      <slot :name='`${step.id}-timeline-after`' v-bind:step="step" >
      </slot>
    </template>
  </v-timeline>
</v-card>
</template>
<script>
export default {
  name: 'GuideLayout',
  props: {
    value: { type: Object, required: true },
    progress: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  },
  computed: {
    wiz () {
      return this.value
    }
  },
  methods: {
    ctaClicked (step) {
      if (step.onclick) { step.onclick(step) }
      else { this.$emit('cta', step) }
    },
    getIcon (step) {
      if (step.done === true) { return 'mdi-check' }
      return 'mdi-record'
    },
    getColor (step) {
      if (step.done === true) { return 'green' }
      if (step.disabled === true) { return 'grey' }
      return 'blue'
    }
  }
}
</script>
